<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="80"
      card
      color="#fff"
    >
      <v-layout row align-center justify-space-between>
        <v-flex grow>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <img :src="require('@/assets/icons/clipboard_list.svg')" alt="" />
          </div>
          <h1 style="display: inline">Listado de Colegios</h1>
        </v-flex>
      </v-layout>

      <template v-slot:extension>
        <v-btn
          dark
          absolute
          bottom
          left
          fab
          color="gradiente"
          to="college/create"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-speed-dial
          key="1"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-btn to="college/create" color="gradiente" dark fab>
              <v-icon>add</v-icon>
              <v-icon>add</v-icon>
            </v-btn>
          </template>
        </v-speed-dial>
      </template>
    </v-toolbar>
    <div class="tab-container">
      <div class="scrollDesign">
        <v-container fluid grid-list-md text-xs-center style="height: 100%">
          <v-layout row wrap style="height: 100%" class="fit-With">
            <v-flex xs12 style="height: 130%" class="ma-12">
              <div class="border-table border-table-color custom-border">
                <v-layout
                  row
                  align-center
                  justify-space-between
                  container
                  fluid
                >
                  <v-flex grow class="d-flex">
                    <v-container grid-list-md text-xs-center pa-0 ma-0 fluid>
                      <v-layout row wrap>
                        <v-flex md2 xs class="border border-dark">
                          <div class="flex-align_center">
                            <div
                              class="mr-3"
                              :style="{
                                padding: '8px',
                                display: 'inline-block',
                                backgroundColor: '#f08286',
                                borderRadius: '0.5rem',
                              }"
                            >
                              <img
                                :src="
                                  require('@/assets/icons/office_building.svg')
                                "
                                alt=""
                              />
                            </div>
                            <p class="text">Colegios</p>
                          </div>
                        </v-flex>
                        <v-flex xs md10>
                          <v-container grid-list-md text-xs-center px-0 py-0>
                            <v-layout row wrap>
                              <v-flex md3 class="box">
                                <v-select
                                  :items="licenceTypes"
                                  outline
                                  height="50"
                                  class="custom-border-field"
                                  v-model="licenceSelected.typeSelected"
                                  :dense="$vuetify.breakpoint.xsOnly"
                                  full-width
                                  item-value="type"
                                  item-text="text"
                                >
                                  <template v-slot:label>
                                    <span class="grey--text"
                                      >Tipo de Licencias</span
                                    >
                                  </template>
                                  <template v-slot:selection="{ item }">
                                    <span class="grey--text caption">{{
                                      item.text
                                    }}</span>
                                  </template>
                                </v-select>
                              </v-flex>
                              <v-flex md3 class="box">
                                <v-select
                                  :items="statusTypes"
                                  outline
                                  height="50"
                                  class="custom-border-field"
                                  v-model="statusSelected.statusId"
                                  :dense="$vuetify.breakpoint.xsOnly"
                                  full-width
                                  item-value="id_status"
                                  item-text="type"
                                >
                                  <template v-slot:label>
                                    <span class="grey--text">Status</span>
                                  </template>
                                  <template v-slot:selection="{ item }">
                                    <span class="grey--text caption">{{
                                      item.type
                                    }}</span>
                                  </template>
                                </v-select>
                              </v-flex>
                              <v-flex md4 class="box">
                                <v-text-field
                                  height="50"
                                  label="Buscar"
                                  outline
                                  class="custom-border-field"
                                  v-model="filters.search"
                                >
                                  <template v-slot:prepend-inner>
                                    <v-icon class="icon_search">search</v-icon>
                                  </template>
                                </v-text-field>
                              </v-flex>
                              <v-flex md2>
                                <v-btn
                                  color="primary"
                                  @click="filterClear"
                                  v-show="!isFilterActive"
                                >
                                  <v-icon left>close</v-icon>Limpiar filtros
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                </v-layout>
                <v-container fluid class="table-full">
                  <v-layout row wrap style="height: 130%">
                    <v-flex xs12 style="height: 130%" class="ma-12">
                      <div class="border-table custom-border">
                        <v-data-table
                          :headers="headers"
                          :pagination.sync="pagination"
                          @update:pagination="customPaginator"
                          :loading="isLoadingTable"
                          :items="colleges"
                          item-key="id"
                          :rows-per-page-items="[10, 25]"
                          :total-items="totalItems"
                          rows-per-page-text="Registros por página"
                          no-results-text="Sin resultados"
                          no-data-text="Sin resultados"
                        >
                          <!-- <template v-slot:headers="props">
                            <tr style="background-color: #dddddd">
                              <th
                                v-for="header in props.headers"
                                :key="header.value"
                                :style="`${header.value=== 'date'?'width: 100%;':'width: 140px;'} max-width: 140px; ${header.value=== 'date'?'min-width: 100%;':'min-width: 140px;'}`"
                                :class="
                                  header.value === 'action' ? 'shadowBorder' : ''
                                "
                              >
                                {{ header.text }}
                              </th>
                            </tr>
                          </template> -->
                          <template v-slot:headers>
                            <tr>
                              <th
                                class="text-xs-center"
                                style="
                                  width: 140px;
                                  max-width: 140px;
                                  min-width: 140px;
                                "
                              >
                                ACCIONES
                              </th>
                              <th
                                class="text-xs-center"
                                style="
                                  width: 140px;
                                  max-width: 140px;
                                  min-width: 140px;
                                "
                              >
                                ID
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 230px;
                                  max-width: 230px;
                                  min-width: 230px;
                                "
                              >
                                NOMBRE
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                ID_CLIENTE
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                ADMINISTRADOR
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                CORREO
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 250px;
                                  max-width: 250px;
                                  min-width: 250px;
                                "
                              >
                                DIRECCIÓN
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                LICENCIAS
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                TIPO
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                ESTATUS
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 210px;
                                  max-width: 210px;
                                  min-width: 210px;
                                "
                              >
                                FECHA DE CREACIÓN
                              </th>
                              <th
                                class="text-xs-left"
                                style="
                                  width: 210px;
                                  max-width: 210px;
                                  min-width: 210px;
                                "
                              >
                                DISPOSITIVOS
                              </th>
                            </tr>
                          </template>
                          <template v-slot:items="props">
                            <tr>
                              <td
                                style="
                                  width: 140px;
                                  max-width: 140px;
                                  min-width: 140px;
                                "
                                class="shadowBorder"
                              >
                                <v-menu
                                  :close-on-content-click="false"
                                  :nudge-width="200"
                                  offset-x
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      small
                                      v-on="on"
                                      class="custom-border option_button custom_flat_button"
                                    >
                                      <v-icon>more_vert</v-icon>
                                    </v-btn>
                                  </template>
                                  <v-card>
                                    <v-list>
                                      <v-list-tile
                                        @click="editCollege(props.item.id)"
                                      >
                                        <v-list-tile-action>
                                          <img
                                            :src="
                                              require('@/assets/icons/pencil_alt.svg')
                                            "
                                            alt=""
                                            height="26px"
                                          />
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title
                                            >Editar</v-list-tile-title
                                          >
                                        </v-list-tile-content>
                                      </v-list-tile>
                                      <v-list-tile
                                        v-for="statusAction in statusOptionsActions(
                                          props.item
                                        )"
                                        @click="statusAction.action"
                                        :key="statusAction.id"
                                      >
                                        <v-list-tile-action>
                                          <v-icon
                                            v-if="statusAction.isIcon"
                                            color="#9ca3af"
                                            >{{ statusAction.icon }}</v-icon
                                          >
                                          <img
                                            v-else
                                            :src="statusAction.icon"
                                            alt=""
                                            height="27px"
                                          />
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title>{{
                                            statusAction.text
                                          }}</v-list-tile-title>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                      <!-- <v-list-tile v-if="props.item.status === 'ACTIVE'"  @click="">
                                        <v-list-tile-action>
                                          <v-icon color="#9ca3af"
                                            >not_interested</v-icon
                                          >
                                        </v-list-tile-action>
                                        <v-list-tile-content
                                          @click="disableService(props.item.id, props.item)"
                                        >
                                          <v-list-tile-title
                                            >Suspender</v-list-tile-title
                                          >
                                        </v-list-tile-content>
                                      </v-list-tile>
                                      <v-list-tile v-if="props.item.status === 'SUSPENDED'"  @click="enableService(props.item.id, props.item)">
                                        <v-list-tile-action>
                                          <img
                                            :src="
                                              require('@/assets/icons/badge_check.svg')
                                            "
                                            alt=""
                                            height="27px"
                                          />
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title
                                            >Reanudar</v-list-tile-title
                                          >
                                        </v-list-tile-content>
                                      </v-list-tile> -->
                                      <v-divider></v-divider>
                                      <v-list-tile
                                        @click="
                                          () => {
                                            confirmDelete.modal = true
                                            confirmDelete.deleteId =
                                              props.item.id
                                          }
                                        "
                                      >
                                        <v-list-tile-action>
                                          <img
                                            :src="
                                              require('@/assets/icons/trash.svg')
                                            "
                                            alt=""
                                            height="27px"
                                          />
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                          <v-list-tile-title
                                            >Eliminar</v-list-tile-title
                                          >
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-list>
                                  </v-card>
                                </v-menu>
                              </td>
                              <td
                                class="text-xs-center"
                                style="
                                  width: 140px;
                                  max-width: 140px;
                                  min-width: 140px;
                                "
                              >
                                {{ props.item.id }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 230px;
                                  max-width: 230px;
                                  min-width: 230px;
                                "
                              >
                                {{ props.item.name }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                {{ props.item.idCustomer || '-' }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                {{
                                  `${
                                    props.item.administrator == undefined
                                      ? '-'
                                      : props.item.administrator.firstName
                                  }
                                ${
                                  props.item.administrator == undefined
                                    ? ''
                                    : props.item.administrator.lastName
                                }`
                                }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                <CustomTooltipOverflowText>
                                  {{
                                    props.item.administrator == undefined
                                      ? '-'
                                      : props.item.administrator.email
                                  }}
                                </CustomTooltipOverflowText>
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 250px;
                                  max-width: 250px;
                                  min-width: 250px;
                                "
                              >
                                {{ props.item.address || '-' }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 140px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                {{ props.item.licenses }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                {{
                                  props.item.type === 2
                                    ? 'Prueba gratis'
                                    : 'Cliente'
                                }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 200px;
                                  max-width: 200px;
                                  min-width: 200px;
                                "
                              >
                                <v-chip
                                  :color="
                                    statusOptions(props.item.status).color
                                  "
                                  :style="{
                                    color: `${
                                      statusOptions(props.item.status).bgColor
                                    }`,
                                  }"
                                >
                                  <strong>{{
                                    statusOptions(props.item.status).text
                                  }}</strong>
                                </v-chip>
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 210px;
                                  max-width: 210px;
                                  min-width: 210px;
                                "
                              >
                                {{ dateFormat(props.item.createdAt) }}
                              </td>
                              <td
                                class="text-xs-left"
                                style="
                                  width: 210px;
                                  max-width: 210px;
                                  min-width: 210px;
                                "
                              >
                                <v-tooltip left>
                                  <template v-slot:activator="{ on }">
                                    <div v-on="on">
                                      <v-btn
                                        icon
                                        flat
                                        small
                                        @click="goToDevices(props.item.id)"
                                      >
                                        <v-icon>visibility</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                                  <span>Ver dispositivos</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:no-data>Sin Resultados</template>
                        </v-data-table>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-flex>
          </v-layout>
          <Confirm
            :value="confirmDelete.modal"
            title="¿Estas seguro que deseas eliminar este colegio?"
            description="Esta acción eliminará de manera definitiva el colegio y toda la información registrada en la plataforma, esta acción es irreversible."
            v-on:desition="confirmDeleteCollege"
          />
          <ConfirmStatus
            :value="modalStatus.isActive"
            :title="modalStatus.title"
            :description="modalStatus.description"
            @changeStatus="onChangeStatus"
          />
          <EnterPasswordToDelete
            :value="confirmDeletePass.modal"
            title="Ingresa tu contraseña para completar la acción"
            v-on:desition="deleteCollege"
            :errors="errors"
          />
          <Success
            :value="successModal.isActive"
            title=""
            :description="successModal.description"
          />
          <Error v-model="modalError.show" :content="modalError.title"></Error>
        </v-container>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import CustomTooltipOverflowText from '../../../../components/generic/custom_tooltip_overflow_text.vue'
import Confirm from './components/ConfirmNew.vue'
import EnterPasswordToDelete from './components/EnterPassword.vue'
import Error from './components/Error.vue'
import Success from './components/Success.vue'
import ConfirmStatus from './components/confirmStatus.vue'
import { filterArrayFromArray, statusType } from './utils.js'

export default {
  components: {
    CustomTooltipOverflowText,
    Confirm,
    EnterPasswordToDelete,
    Success,
    ConfirmStatus,
    Error,
  },
  data: () => {
    return {
      errors: {
        eMessage: '',
        eLogin: false,
      },
      confirmDelete: {
        modal: false,
        deleteId: null,
      },
      confirmDeletePass: {
        modal: false,
        deleteId: null,
      },
      successModal: {
        isActive: false,
        description: '',
      },
      branchId: null,
      headers: [
        {
          text: 'ACCIÓN',
          align: 'left',
          sortable: false,
          value: 'action',
        },
        {
          text: 'NOMBRE',
          align: 'left',
          sortable: false,
          value: 'name',
        },
        {
          text: 'ADMINISTRADOR',
          align: 'left',
          sortable: false,
          value: 'admin',
        },
        {
          text: 'CORREO',
          align: 'left',
          sortable: false,
          value: 'email',
        },
        {
          text: 'LICENCIAS',
          align: 'left',
          sortable: false,
          value: 'lic',
        },
        {
          text: 'TIPO',
          align: 'left',
          sortable: false,
          value: 'type',
        },
        {
          text: 'ESTATUS',
          align: 'left',
          sortable: false,
          value: 'status',
        },
        {
          text: 'FECHA DE CREACIÓN',
          align: 'left',
          sortable: false,
          value: 'date',
        },
        {
          text: 'ACCESOS',
          align: 'left',
          sortable: false,
          value: 'date',
        },
      ],

      /**
       * remove once backend have filters
       */
      licenceTypes: [
        { text: 'Todos', type: 0 },
        { text: 'Cliente', type: 1 },
        { text: 'Prueba gratis', type: 2 },
      ],
      /**
       * remove once backend have filters
       */
      statusSelected: {
        statusId: 0,
      },
      statusTypes: [
        { type: 'Todos', id_status: 0 },
        { type: 'Activo', id_status: 1 },
        { type: 'Suspendido', id_status: 2 },
        { type: 'Baja Temporal', id_status: 3 },
        { type: 'Baja Definitiva', id_status: 4 },
        //  'Activo',
        //  'Suspendido',
        //  'Baja Temporal',
        //  'Abandonado',
      ],
      /**
       * remove once backend have filters
       */
      licenceSelected: {
        typeSelected: 0,
      },
      /**
       * remove once backend have filters
       */

      /**
       * remove once backend have filters
       */
      tempGroupFilters: {},

      colleges: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: 'name',
      },
      totalItems: 0,
      isLoadingTable: false,
      search: '',
      filters: { search: '' },
      modalError: {
        title: '',
        show: false,
      },
      modalStatus: {
        item: null,
        type: null,
        isActive: false,
        title: '',
        description: '',
      },
    }
  },
  created() {
    this.addOverrideGlobalCss()
  },
  beforeRouteLeave: function (to, from, next) {
    this.removeOverrideGlobalCss(to.name)
    next()
  },
  methods: {
    goToDevices(branchId) {
      this.$router.push({
        name: 'CollegeDevices',
        params: { id: branchId },
      })
    },
    ...mapActions(['getCollege']),
    /**
     * remove once backend have filters
     */
    filterClear() {
      this.statusSelected.statusId = 0
      this.licenceSelected.typeSelected = 0
      this.filters.search = ''
    },
    tempLicTypes(value) {
      const licTypes = {
        'Prueba gratis': () => 2,
        Cliente: () => 1,
        cualquiera: () => 0,
      }
      return licTypes[value]()
    },
    /**
     * remove once backend have filters
     */
    tempStatusTypes(value) {
      const licTypes = {
        Activo: () => 'ACTIVE',
        Suspendido: () => 'SUSPENDED',
        'Baja Temporal': () => 'TEMPORAL_DROP',
        Abandonado: () => 'DROPPED',
      }
      return licTypes[value]()
    },
    dateFormat(value) {
      let time = moment(String(new Date(value))).format('DD/MMM/YYYY HH:mm')

      const [day, rawMonth, ...rest] = time.split('/')

      const month =
        rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1).replace('.', '')

      return `${day}/${month}/${rest[0]}`
    },
    addOverrideGlobalCss() {
      const style = document.createElement('style')
      style.id = 'tempOverrideGlobalCss'
      style.innerHTML = `
        .v-menu__content {
          border-radius: 0.5rem !important;
          border: 1px solid #ccc;
        }
        :root {
          --main-color: #ef565c;
          --pale-blue: #374151;
          --low-grey: #D1D5DB;
          --mid-grey: #f5f5f5;
          --top-grey: #E5E5E5;
        }
        `
      document.head.appendChild(style)
    },
    removeOverrideGlobalCss(newRoute) {
      if (newRoute != 'Colleges') {
        const sheet = document.getElementById('tempOverrideGlobalCss')
        if (sheet != null) {
          sheet.remove()
        }
      }
    },
    customPaginator() {
      this.getColleges()
    },
    _offsetHandler() {
      if (this.pagination.page == 1) return 0
      return (this.pagination.page - 1) * this.pagination.rowsPerPage + 1
    },
    customSearch() {
      // this.getColleges();
      this.listCollege(this.filters)
    },
    listCollege(filters) {
      this.isLoadingTable = true
      const newFilters = {}
      for (const property in filters) {
        const value = filters[property]
        if (value) {
          newFilters[property] = value
        }
      }

      const query = {
        ...newFilters,

        // size: pagination.rowsPerPage,
        // offset: (pagination.page - 1) * pagination.rowsPerPage,
      }
      this.$store
        .dispatch('colleges/listCollege', query)
        .then((res) => {
          this.colleges = res.data.data
          this.totalItems = res.data.total
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoadingTable = false))
    },
    onFilterCollegeByStatus() {
      this.isLoadingTable = true
      const query = {
        id_status: this.statusSelected.statusId,
      }
      this.$store
        .dispatch('colleges/filterCollege', query)
        .then((res) => {
          console.log(res)
          this.colleges = res.data.data
          this.totalItems = res.data.total
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoadingTable = false))
    },
    onFilterCollegeByLicence() {
      this.isLoadingTable = true
      const query = {
        type: this.licenceSelected.typeSelected,
      }
      this.$store
        .dispatch('colleges/filterCollege', query)
        .then((res) => {
          console.log(res)
          this.colleges = res.data.data
          this.totalItems = res.data.total
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoadingTable = false))
    },
    /**
     * it recive an object like so { offset: 0, size: 25, search: '', isSearch: false }
     */
    async getColleges({
      offset = this._offsetHandler(),
      size = this.pagination.rowsPerPage,
      search = this.search,
      isSearch = this.search === '' ? false : true,
    } = {}) {
      this.isLoadingTable = true
      try {
        const rawColleges = await this.$store.dispatch('colleges/getColleges', {
          offset,
          size,
          search,
          isSearch,
        })
        this.colleges = rawColleges.data.data
        this.totalItems = rawColleges.data.total
      } catch (error) {
        console.log(error)
      }
      this.isLoadingTable = false
    },
    _resetModalStatus() {
      this.modalStatus.isActive = false
      this.modalStatus.item = null
    },
    async onChangeStatus(isOkEvent) {
      if (!isOkEvent) {
        this._resetModalStatus()
        return
      }

      if (this.modalStatus.type === 'TEMPORAL_DROP') {
        const response = await this._dropCollegue('TEMPORAL_DROP')

        if (response === null) {
          this.modalError.show = true
          this._resetModalStatus()
          return
        }

        this.successModal.isActive = true
        this.listCollege(this.filters)
        this._resetModalStatus()
        this.successModal.description =
          '¡Colegio dado de baja temporal con éxito!'
        this._resetSuccess()
        return
      }

      if (this.modalStatus.type === 'DROPPED') {
        const response = await this._dropCollegue('DROPPED')

        if (response === null) {
          this.modalError.show = true
          this._resetModalStatus()
          return
        }

        this.successModal.isActive = true
        this.listCollege(this.filters)
        this._resetModalStatus()
        this.successModal.description =
          '¡Colegio dado de baja permanente con éxito!'
        this._resetSuccess()
        return
      }
    },
    /**
     * Set the arrow position of the tooltip
     * @param {"TEMPORAL_DROP"|"DROPPED"} [statusType] - TEMPORAL_DROP pointer position
     */
    statusModalConfig(statusType = null, item = null) {
      this.modalStatus.item = item

      if (statusType === 'TEMPORAL_DROP') {
        this.modalStatus.isActive = true
        this.modalStatus.type = statusType
        this.modalStatus.title =
          '¿Estas seguro que dar de baja temporal este colegio?'
        this.modalStatus.description =
          'Al darlo de baja temporal, los usuarios colaboradores del colegio no podrán acceder, ¿Deseas continuar?'
        return
      }

      if (statusType === 'DROPPED') {
        this.modalStatus.isActive = true
        this.modalStatus.type = statusType
        this.modalStatus.title =
          '¿Estas seguro que dar de baja permanente este colegio?'
        this.modalStatus.description =
          'Al darlo de baja permanente, los usuarios colaboradores del colegio no podrán acceder, ¿Deseas continuar?'
        return
      }
    },
    statusOptionsActions(item) {
      const posibleStatus = [
        {
          status: statusType.ACTIVE,
          isIcon: false,
          icon: require('@/assets/icons/badge_check.svg'),
          text: 'Reanudar',
          action: () => this.enableService(item.id, item),
        },
        {
          status: statusType.SUSPENDED,
          isIcon: true,
          icon: 'not_interested',
          text: 'Suspender',
          action: () => this.disableService(item.id, item),
        },
        {
          status: statusType.TEMPORAL_DROP,
          isIcon: true,
          icon: 'do_not_disturb_on',
          text: 'Baja temporal',
          action: () => this.statusModalConfig('TEMPORAL_DROP', item),
        },
        {
          status: statusType.DROPPED,
          isIcon: false,
          icon: require('@/assets/icons/delete_database.svg'),
          text: 'Baja permanente',
          action: () => this.statusModalConfig('DROPPED', item),
        },
      ]

      if (item.status === statusType.ACTIVE) {
        return filterArrayFromArray(
          [statusType.SUSPENDED, statusType.TEMPORAL_DROP, statusType.DROPPED],
          posibleStatus,
          (e, b) => (b[e.status] ? e : false)
        )
      }
      if (item.status === statusType.SUSPENDED) {
        return filterArrayFromArray(
          [statusType.ACTIVE, statusType.TEMPORAL_DROP, statusType.DROPPED],
          posibleStatus,
          (e, b) => (b[e.status] ? e : false)
        )
      }
      if (item.status === statusType.TEMPORAL_DROP) {
        return filterArrayFromArray(
          [statusType.ACTIVE, statusType.DROPPED],
          posibleStatus,
          (e, b) => (b[e.status] ? e : false)
        )
      }
      if (item.status === statusType.DROPPED) {
        return filterArrayFromArray([], posibleStatus, (e, b) =>
          b[e.status] ? e : false
        )
      }

      return posibleStatus.filter((e) => e.status !== item.status)
    },
    statusOptions(status) {
      const posibleStatus = {
        ACTIVE: () => {
          return {
            color: '#8fe5c0',
            bgColor: '#155d45',
            text: 'Activo',
          }
        },
        SUSPENDED: () => {
          return {
            color: '#ffeb3b',
            bgColor: 'black',
            text: 'Suspendido',
          }
        },
        TEMPORAL_DROP: () => {
          return {
            color: '#ff9800',
            bgColor: 'white',
            text: 'Baja Temporal',
          }
        },
        DROPPED: () => {
          return {
            color: '#fbdfde',
            bgColor: '#b91b19',
            text: 'Baja definitiva',
          }
        },
      }

      return posibleStatus[status]()
    },
    /**
     *
     * @param {"TEMPORAL_DROP"|"DROPPED"} status
     */
    async _dropCollegue(status = '') {
      if (status !== 'DROPPED' && status !== 'TEMPORAL_DROP') {
        console.error('status param is not valid')
        return null
      }

      try {
        await this.$store.dispatch('colleges/dropCollege', {
          id_branch: this.modalStatus.item.id,
          data: {
            status: status,
          },
        })
        return true
      } catch (error) {
        if (error.response.status === 404) {
          this.modalError.title = 'No se encontró el colegio.'
          console.error('No se encontró la branch proporcionada por id_branch.')
          return null
        }

        if (error.response.status === 400) {
          this.modalError.title = 'Estatus proporcionado no es válido.'
          console.error('El estatus proporcionado en status no es válido.')
          return null
        }

        return true
      }
    },
    editCollege(branchId) {
      this.$router.push({
        name: 'collegeUpdate',
        params: { id: branchId },
      })
    },
    disableService(idBranch, branch) {
      this.$router.push({
        name: 'CollegeServiceSuspend',
        params: { id: idBranch },
      }),
        this.getCollege(branch)
    },
    enableService(idBranch, branch) {
      this.$router.push({
        name: 'CollegeEnable',
        params: { id: idBranch },
      }),
        this.getCollege(branch)
    },
    confirmDeleteCollege(confirm) {
      if (confirm) {
        let { deleteId } = this.confirmDelete
        this.branchId = deleteId
        this.confirmDeletePass.modal = true
      }
      this.confirmDelete = {
        modal: false,
        deleteId: null,
      }
    },
    deleteCollege(confirm, password) {
      if (confirm) {
        console.log(this.branchId)
        this.$store
          .dispatch('colleges/deleteCollege', {
            id_branch: this.branchId,
            data: {
              password: password,
            },
          })
          .then((response) => {
            console.log(response)
            if (response.status === 200) {
              this.confirmDeletePass = {
                modal: false,
              }
              this.deleteSuccess()
              this.customPaginator()
            }
          })
          .catch((error) => {
            this.processErrors(error)
            this.confirmDeletePass = {
              modal: true,
            }
          })
      }
      this.confirmDeletePass = {
        modal: false,
      }
      // this.branchId = null;
    },

    processErrors(error) {
      switch (error.response.status) {
        case 400:
          this.errors.eMessage = 'Contraseña Incorrecta'
          this.errors.eLogin = true
          break
      }
    },
    _resetSuccess() {
      setTimeout(() => {
        this.successModal.isActive = false
        this.successModal.description = ''
      }, 2500)
    },
    deleteSuccess() {
      this.successModal.isActive = true
      this.successModal.description = '¡Colegio eliminado con éxito!'
      setTimeout(() => {
        this.successModal.isActive = false
        this.resetDelete()
      }, 2000)
    },

    resetDelete() {
      ;(this.errors = {
        eMessage: '',
        eLogin: false,
      }),
        (this.confirmDelete = {
          modal: false,
          deleteId: null,
        }),
        (this.confirmDeletePass = {
          modal: false,
          deleteId: null,
        })
      this.successModal = {
        isActive: false,
        description: '',
      }
    },
  },
  mounted() {
    // this.deleteSuccess();
  },
  computed: {
    /**
     * remove once backend have filters
     */
    tempFilterColleges: function () {
      Object.keys(this.tempGroupFilters).forEach((key) =>
        this.tempGroupFilters[key] === null
          ? delete this.tempGroupFilters[key]
          : {}
      )
      function search(user) {
        return Object.keys(this).every((key) => user[key] === this[key])
      }
      return this.colleges.filter(search, this.tempGroupFilters)
    },
    isFilterActive() {
      return (
        !this.filters.search &&
        !this.licenceSelected.typeSelected &&
        !this.statusSelected.statusId
      )
    },
  },
  watch: {
    /**
     * remove once backend have filters
     */
    licenceSelected: {
      handler() {
        this.onFilterCollegeByLicence(this.licenceSelected)
        if (this.licenceSelected.typeSelected == 0) {
          this.getColleges()
        }
      },
      deep: true,
    },
    /**
     * remove once backend have filters
     */
    statusSelected: {
      handler() {
        this.onFilterCollegeByStatus(this.statusSelected)
        if (this.statusSelected.statusId == 0) {
          this.getColleges()
        }
      },
      deep: true,
    },
    filters: {
      handler() {
        this.listCollege(this.filters)
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
/* table */
.icon_search {
  height: 20px;
}

.tab-container {
  background-color: var(--top-grey);
}

.border-table-color {
  background-color: white;
}

.border-table {
  border: 1px solid;
  border-color: var(--low-grey);
  overflow: hidden;
  width: 100%;
}

.shadowBorder {
  box-shadow: 1px 0 1px 0px rgba(0, 0, 0, 0.15);
  /* border-right: 1px solid rgba(0, 0, 0, 0.15); */
}

.option_button {
  background-color: white !important;
  color: var(--low-grey) !important;
  border: 1px solid var(--low-grey);
  min-width: 0px;
  max-width: 35px;
  min-height: 35px;
  padding-left: 10px;
}

.custom_flat_button {
  box-shadow: none !important;
}

.option_button:hover,
.option_button:focus {
  border-color: var(--main-color);
  color: transparent;
}

.option_button:hover i,
.option_button:focus i {
  color: var(--main-color);
}

.text {
  font-weight: bold;
  font-size: 1.1rem;
}

@media (max-width: 960px) {
  .scrollDesign {
    height: 130vh;
  }
}

@media (max-width: 853px) {
  .scrollDesign {
    height: 200vh;
  }
}

@media (max-width: 594px) {
  .scrollDesign {
    height: 400vh;
  }
}

@media (min-width: 960px) {
  .scrollDesign {
    height: 100vh;
  }

  .box {
    height: 50px;
  }
}

/* prevent overflow container */
.fit-With {
  margin-right: auto !important;
  margin-left: auto !important;
}

/* generic */
.flex-align_center {
  display: flex;
  align-items: center;
}

.flex-content_end {
  display: flex;
  justify-content: end;
}

.custom-border {
  border-radius: 0.5rem;
}

/* override existing global css */
::v-deep thead tr {
  background-color: #f9fafb !important;
}

::v-deep thead tr th {
  color: #6b7280 !important;
}

::v-deep .custom-border-field .v-input__control .v-input__slot {
  border: 1px solid #dddddd !important;
}
</style>
